import { render, staticRenderFns } from "./CadastroVisualizarDocumentoDialog.vue?vue&type=template&id=66e017ca&scoped=true&lang=pug&"
import script from "./CadastroVisualizarDocumentoDialog.vue?vue&type=script&lang=js&"
export * from "./CadastroVisualizarDocumentoDialog.vue?vue&type=script&lang=js&"
import style0 from "./CadastroVisualizarDocumentoDialog.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CadastroVisualizarDocumentoDialog.vue?vue&type=style&index=1&id=66e017ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e017ca",
  null
  
)

export default component.exports